import LegalDocument, { type LegalSection } from "@/components/feature/LegalDocument";
import { SITE } from "@/config/site";

const sections: LegalSection[] = [
  {
    id: "nature",
    title: "1. Advertising on the platform",
    body: [
      `${SITE.name} displays advertised and sponsored content alongside organic directory results. This may include featured listings, sponsored placements, banner advertisements, pop-up promotions and third-party advertisements.`,
      "Advertisements are clearly identified with labels such as “Ad”, “Sponsored” or “Featured” so that visitors can distinguish them from ordinary directory listings.",
    ],
  },
  {
    id: "endorsement",
    title: "2. No endorsement or recommendation",
    body: [
      "The appearance of an advertisement on this platform does not constitute an endorsement, recommendation or guarantee by us of the advertiser, its products or its services.",
      "Any transaction, booking or dealing that you enter into with an advertiser is solely between you and that advertiser. You are encouraged to make your own enquiries and satisfy yourself before relying on any advertisement.",
    ],
  },
  {
    id: "responsibility",
    title: "3. Responsibility for ad content",
    body: [
      "Advertisers are solely responsible for the content of their advertisements, including the accuracy of claims, prices, availability, offers and any images or media used.",
      "We do not independently verify, and are not responsible for, statements, promises or comparisons made by advertisers. Descriptions of products or services reflect the advertiser's own representation.",
    ],
  },
  {
    id: "compliance",
    title: "4. Compliance with Indian advertising law",
    body: [
      "Advertisers must ensure that their advertisements comply with all applicable Indian laws, including the Consumer Protection Act, 2019, the Consumer Protection (E-Commerce) Rules, 2020, and the Advertising Standards Council of India (ASCI) Code for Self-Regulation.",
      "Advertisements must not be false, misleading, deceptive or disparaging, and must not make unverified claims. We reserve the right to reject or withdraw any advertisement that, in our reasonable opinion, is unlawful, misleading, offensive or in breach of these requirements.",
      "We may remove advertisements that promote illegal goods or services, including banned products, surrogates, betting, or content that is prohibited under Indian law.",
    ],
  },
  {
    id: "thirdparty",
    title: "5. Third-party links and offers",
    body: [
      "Advertisements may link to external websites that we do not control. We are not responsible for the content, privacy practices, security or reliability of any third-party website reached through an advertisement.",
      "Offers, discounts and schemes shown in advertisements are the sole responsibility of the advertiser, are subject to the advertiser's terms, and may be withdrawn or changed without notice.",
    ],
  },
  {
    id: "technical",
    title: "6. Advertising and data",
    body: [
      "Where an advertisement is served or measured through a third-party service, that service may set its own cookies or identifiers, subject to its own privacy policy. Our use of personal data is described in our Privacy Policy.",
      "We do not sell the personal data of visitors to advertisers.",
    ],
  },
  {
    id: "disclaimer",
    title: "7. General disclaimer",
    body: [
      "The platform and all advertisements are provided on an 'as is' and 'as available' basis. To the maximum extent permitted by law, we disclaim liability for any loss or damage arising from reliance on any advertisement or sponsored content.",
      "Nothing in this disclaimer limits any right or remedy you may have under the Consumer Protection Act, 2019 or any other applicable Indian law that cannot be excluded.",
    ],
  },
  {
    id: "requests",
    title: "8. Complaints about advertising",
    body: [
      "If you believe an advertisement on the platform is unlawful or misleading, you may report it to our Grievance Officer using the details below. We will review the complaint and take appropriate action within the timeframes described in our grievance process.",
    ],
  },
  {
    id: "law",
    title: "9. Governing law and jurisdiction",
    body: [
      "This policy is governed by the laws of India. Any dispute arising out of or in connection with advertising on the platform is subject to the exclusive jurisdiction of the courts at Mysore, Karnataka, India.",
    ],
  },
];

export default function AdDisclaimer() {
  return (
    <LegalDocument
      crumb="Disclaimers on Ads"
      eyebrow="Legal"
      icon="ri-megaphone-line"
      heading="Disclaimers on Ads"
      subtitle={`Important disclaimers about the advertising and sponsored content shown on ${SITE.name}, and the responsibilities of advertisers under Indian law.`}
      updated="October 2026"
      seoTitle="Disclaimers on Ads"
      seoDescription={`Understand how advertising works on ${SITE.name}, our no-endorsement disclaimer, and advertiser responsibilities under Indian advertising law.`}
      seoKeywords="Mysore Yellow Pages ad disclaimer, sponsored listings, Indian advertising law compliance"
      path="/ad-disclaimer"
      sections={sections}
    />
  );
}